import React, { useEffect, useState } from 'react'
import { Box, CardMedia, Grid, Typography } from '@mui/material'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { useLocation, useNavigate } from 'react-router-dom'
import { FormatBacktoFront } from 'module/performance/services/helper/formFunctions'
import AltFormHeader from '../components/altFormHeader'
import AltDisplayQuestion from '../components/altDisplayQuestion'
import {
  getSubmission,
  sendSubmission,
} from 'services/api/modules/performance/appraisal/submission'
import RevieweesCard from '../../view-submission/components/revieweesCard'
import PageNavigator from '../components/pageNavigator'
import defaultImage from 'assets/images/default_avatar.png'
import EvaluationSnackBar from '../../appraisal-company-mgmt/components/EvaluationSnackBar'
import AdxButton from 'components/custom/AdxButton'

const SubmitForm = () => {
  const navigate = useNavigate()
  const { pathname, state } = useLocation()
  const submissionId = pathname.split('/').pop()
  const queryClient = useQueryClient()
  const [formPage, setFormPage] = useState(0)
  const [startPage, setStartPage] = useState(true)
  const [formStructure, setFormStructure] = useState([[0]])
  const [quesParams, setQuesParams] = useState([
    {
      quesKey: 0,
      quesType: '1',
      quesRequired: true,
      question: '',
      option: [],
    },
  ])
  const [sectParams, setSectParams] = useState([
    {
      title: '',
      desc: '',
    },
  ])

  const [showError, setShowError] = useState(false)
  useEffect(() => {
    queryClient.invalidateQueries('allSubmissionData')
    queryClient.resetQueries('submissionData')
  }, [])

  const { error: fetchError, data } = useQuery(['submissionData', submissionId], async () => {
    const { data } = await getSubmission(submissionId)
    return data
  })
  if (fetchError) {
    navigate(`/app/performance/appraisal/${state.appraisalId}`, {
      state: {
        ...state,
        initialTabsValue: 1,
      },
    })
  }

  useEffect(() => {
    handleFormSpread(data ?? { sections: [] })
  }, [data])

  //========================================================================================================
  // HANDLING FORM FORMAT CONVERSION BACKEND<>FRONTEND
  //========================================================================================================

  // converting backend form format into frontend form format
  const handleFormSpread = (formObject) => {
    let spreadForm = FormatBacktoFront(formObject)

    setSectParams(spreadForm.sect)
    setQuesParams(spreadForm.ques)
    setFormStructure(spreadForm.form)
    // setQuesKeycount(spreadForm.quesCount)
  }

  useEffect(() => {}, [quesParams])

  const getQues = (quesKey) => {
    let items = quesParams?.find((i) => i.quesKey === quesKey)
    return items
  }

  const handleResponse = (quesKey, value) => {
    let questions = [...quesParams]
    let index = questions.findIndex((q) => q.quesKey === quesKey) //cari index
    if (index > -1) questions[index].response = value // update element using index
    setQuesParams(questions) // assign array semula
  }

  const handlePage = (page) => {
    setFormPage(page - 1)
  }

  const handleExit = () => {
    navigate(`/app/performance/appraisal/${state.appraisalId}`, {
      state: {
        ...state,
        initialTabsValue: 1,
      },
    })
  }

  // Submitting answers, PUT method
  const {
    isLoading: submitLoading,
    error: submitError,
    mutate: submitMutate,
  } = useMutation((values) => sendSubmission(submissionId, values), {
    onSuccess: async () => {
      navigate(`/app/performance/appraisal/${state.appraisalId}`, {
        state: {
          ...state,
          initialTabsValue: 1,
        },
      })
    },
  })

  const handleSubmit = () => {
    let newSubmission = {}

    if (quesParams.some((e) => e?.response === undefined && e?.quesRequired)) {
      return setShowError(true)
      //  setModalOpen(false)
    }

    newSubmission = {
      status: 2,
      responses: quesParams.map((item) => {
        return {
          question_id: item.id,
          answer: JSON.stringify(item?.response),
          answer_type: item?.quesType,
        }
      }),
    }

    submitMutate(newSubmission)
  }

  const handleStart = () => {
    setStartPage(false)
  }

  // Submit modal function and state
  const [isModalOpen, setModalOpen] = useState(false)
  const handleOpen = () => {
    setModalOpen(true)
  }

  return (
    <>
      <EvaluationSnackBar
        message={'Please complete the required question(s)'}
        status={'error'}
        autoHideDuration={4000}
        showError={showError}
        setShowError={setShowError}
      />
      <AltFormHeader
        title={
          state?.evaluationDetails?.evaluation_title
            ? state?.evaluationDetails?.evaluation_title
            : 'Untitled Evaluation'
        }
        isPreview={false}
        isSubmit={startPage ? false : true}
        pageCount={formStructure?.length || 1}
        pageCurrent={formPage}
      />
      <Grid container>
        {startPage && (
          <Grid item xs={12}>
            <Box
              height="calc(100vh - 75px)"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Box
                width="800px"
                height="60vh"
                position="relative"
                bgcolor="white.main"
                boxShadow="0px 0px 10px lightgray"
                borderRadius={2}
              >
                <Box p={3} borderBottom="1px solid" borderBottomColor="gray-line.main">
                  <Typography color="light-gray-text.main" mb={3}>
                    Reviewee
                  </Typography>
                  <Box display="flex" gap={3} alignItems="center">
                    <CardMedia
                      component="img"
                      sx={{
                        height: 60,
                        width: 60,
                        objectFit: 'cover',
                        borderRadius: '50%',
                      }}
                      src={state?.revieweeDetails?.reviewee_image ?? defaultImage}
                    />
                    <Box>
                      <Typography>{state?.revieweeDetails?.reviewee_name}</Typography>
                      <Typography variant="body2" color="light-gray-text.main">
                        {state?.revieweeDetails?.reviewee_department_name}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Box p={3}>
                  <Typography color="light-gray-text.main" mb={0.5}>
                    Evaluation description
                  </Typography>
                  <Typography>{state?.evaluationDetails?.evaluation_description}</Typography>
                  <Box
                    sx={{
                      width: '100%',
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      padding: 2,
                    }}
                  >
                    <AdxButton
                      variant={'contained'}
                      fullWidth
                      size="standard"
                      onClick={handleStart}
                    >
                      Start now
                    </AdxButton>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        )}
        {!startPage && (
          <>
            <Grid item p={3} xs={8}>
              <Box
                display="flex"
                flexDirection="column"
                bgcolor="white.main"
                borderRadius={2}
                boxShadow="0px 0px 10px lightgray"
              >
                <Box px={3} py={2} borderBottom={1} borderColor="gray-line.main">
                  <Typography variant="h4" color="alternate.main" fontWeight="600">
                    {sectParams[formPage] !== undefined ? sectParams[formPage].title : ''}
                  </Typography>
                  <Typography
                    pt={1}
                    textAlign="justify"
                    variant="body1"
                    color="light-gray-text.main"
                  >
                    {sectParams[formPage] !== undefined ? sectParams[formPage].desc : ''}
                  </Typography>
                </Box>
                <Box display="flex" flexDirection="column" gap={3} px={3} py={2}>
                  {formStructure[formPage] !== undefined
                    ? formStructure[formPage]?.map((i, index) => (
                        <AltDisplayQuestion
                          quesKey={getQues(i)?.quesKey || 0}
                          valueType={getQues(i)?.quesType || '1'}
                          valueRequired={getQues(i)?.quesRequired || 0}
                          valueQuestion={getQues(i)?.question || ''}
                          valueOption={getQues(i)?.option || []}
                          valueResponse={getQues(i)?.response || ''}
                          handleResponse={handleResponse}
                          formPage={formPage}
                          key={index}
                        />
                      ))
                    : null}
                </Box>
              </Box>
              <PageNavigator
                pageCount={formStructure?.length || 1}
                pageCurrent={formPage}
                handlePage={handlePage}
                handleExit={handleExit}
                isSubmission
                handleSubmit={handleSubmit}
                handleOpen={handleOpen}
                isModalOpen={isModalOpen}
                setModalOpen={setModalOpen}
              />
            </Grid>
            <Grid item xs={4}>
              <RevieweesCard revieweeDetails={state?.revieweeDetails} />
            </Grid>
          </>
        )}
      </Grid>
    </>
  )
}

export default SubmitForm
